import consumer from "./consumer"


let customNotificationsSubscription;

// El tab de notificaciones puede vivir oculto (la tab bar nativa mantiene el
// webview y también aplica a tabs de browser en background): ahí NO se marca
// visto al llegar — se difiere a visibilitychange, si no el tab oculto se
// come el badge antes de que el usuario vea nada
let pendingSeen = false;

function createSubscription() {
  if (customNotificationsSubscription) return;

  customNotificationsSubscription = consumer.subscriptions.create("CustomNotificationsChannel", {
    connected() {
      console.log("Conectado al canal de notificaciones personalizadas");
      this.perform("sync");
    },

    disconnected() {
      console.log("Desconectado del canal de notificaciones personalizadas");
    },

    received(data) {
      console.log("Notificación personalizada recibida:", data);
      updateNotificationsUI(data);
    }
  });
}

function updateNotificationsUI(data) {
  updateBadge(data.unseen_count);
  // Synchronization and seen changes contain only the authoritative count.
  if (!data.notification) return;

  const notificationsLink = document.querySelector('.custom-notifications-link');
  const notificationsPath = notificationsLink ? notificationsLink.dataset.notificationsPath : '/custom_notifications';
  const notificationsList = document.getElementById("notifications-list");
  const onNotificationsPage = window.location.pathname === notificationsPath;

  // La lista existe siempre en la página (aunque esté vacía): el prepend va
  // ahí y no al contenedor, para no desordenar load-more/empty state
  if (notificationsList) {
    notificationsList.insertAdjacentHTML("afterbegin", data.notification);
    const emptyMessage = document.getElementById("no-notifications-message");
    if (emptyMessage) emptyMessage.remove();
    updateNotificationsCount(data.total_count);
  }

  if (onNotificationsPage) {
    // Estando en la página (y visible) se marca vista; el dot queda no-leído
    // hasta el tap o "Marcar leídas"
    if (document.visibilityState === "visible") {
      markAllAsSeen();
    } else {
      pendingSeen = true;
    }
  }
}

function updateBadge(count) {
  if (!Number.isInteger(count) || count < 0) return;
  window.dispatchEvent(new CustomEvent("notification-badge:update", { detail: { count } }));
  const notificationsLink = document.querySelector('.custom-notifications-link');
  if (notificationsLink) {
    let badge = notificationsLink.querySelector(".badge-notify");
    if (count === 0) {
      badge?.remove();
      return;
    }
    if (badge) {
      if (badge.textContent !== count.toString()) {
        badge.textContent = count;
      }
    } else {
      badge = document.createElement('span');
      badge.className = 'badge-notify';
      badge.textContent = count;
      notificationsLink.appendChild(badge);
    }
  }
}

function updateNotificationsCount(total) {
  if (total === null || total === undefined) return;
  const count = document.getElementById("notifications-count");
  if (count) {
    count.textContent = `${total} ${total === 1 ? "notificación" : "notificaciones"}`;
  }
}

function markAllAsSeen() {
  // Android can report a hidden tab's document as visible. Ask native before
  // marking anything seen; web and apps without this bridge keep their behavior.
  const components = document.documentElement.dataset.bridgeComponents?.split(" ") || [];
  if (components.includes("notification-badge")) {
    window.dispatchEvent(new CustomEvent("notification-badge:mark-seen", {
      detail: { perform: markSeenRequest }
    }));
  } else {
    markSeenRequest();
  }
}

async function markSeenRequest() {
  try {
    const response = await fetch('/custom_notifications/mark_all_as_seen', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Error al marcar las notificaciones como vistas');
    }
  } catch (error) {
    console.error('Error de red:', error);
  }
}

function syncBadge() {
  customNotificationsSubscription?.perform("sync");
}

window.addEventListener("notification-badge:sync", syncBadge);

document.addEventListener("turbo:load", () => {
  createSubscription();
});

// Volver al tab de notificaciones (native o browser) con llegadas pendientes:
// recién ahí se marcan vistas
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "visible") return;
  syncBadge();
  if (!pendingSeen) return;

  const notificationsLink = document.querySelector('.custom-notifications-link');
  const notificationsPath = notificationsLink ? notificationsLink.dataset.notificationsPath : '/custom_notifications';
  if (window.location.pathname !== notificationsPath) return;

  pendingSeen = false;
  markAllAsSeen();
});

document.addEventListener("turbo:before-render", () => {
  if (customNotificationsSubscription) {
    customNotificationsSubscription.unsubscribe();
    customNotificationsSubscription = null;
  }
});
